export const locale = {
    lang: 'ds',
    data: {
        'FIELDS': {
            'number': 'Nummer',
            'text': 'Tekst',
            'm2200': '0-200 m2',
            'm2201': '201-500 m2',
            'm2500': '> 500 m2',
            'appendix': 'Tillæg',
            'm2': 'M2',
            'stk10': '0-10 stk.',
            'stk20': '11-20 stk.',
            'stk21': '> 21 stk.',
            'TreatmentType':'Behandlings type',
            'Min': 'Min',
            'indoorOutdoor': 'Indvendigt / Udvendigt',
            'treatmentType1':{
                'lbM2A': 'M2 A',
                'lbM2B': 'pr. lb. m 15 CM',
                'lbM2C': 'pr. lb. m 30 CM',
                'lbRammerD': 'pr. lb. m 40 CM',
                'lbRuderE': 'pr. lb. m 60 CM',
                'lbFalsF': 'indv.vange + stødtrin stk.'
            },
            'treatmentType2':{
                'lbM2A': 'M2 0-200',
                'lbM2B': 'M2 201-500',
                'lbM2C': '500->',
                'lbRammerD': 'pr. lb. m 30 CM',
                'lbRuderE': 'pr. lb. m 60 CM',
                'lbFalsF': 'kr/øre M2',
                'lbKantG': 'kr/øre 30 CM ',
                'lb15CmH': 'kr/øre 60 CM',
                'lb30CmI': 'kr/øre 100 CM',
            },
            'treatmentType3':{
                'lbM2A': 'M2 0-200',
                'lbM2B': 'M2 0-200',
                'lbM2C': 'M2 201-500',
                'lbRammerD': 'pr. lb. m 30 CM',
                'lbRuderE': 'pr. lb. m 60 CM',
                'lbFalsF': 'M2 LOFT',
                'lbKantG': 'M2 Vægge '
            },
            'treatmentType4':{
                'lbM2A': 'udv. m2 kr/øre',
                'lbM2B': 'indv. m2 kr/øre',
                'lbM2C': 'M2 kr/øre',
                'lbRammerD': 'rammer stk. kr/øre',
                'lbRuderE': 'ruder stk.',
                'lbFalsF': 'fals stk.',
                'lbKantG': 'kant stk.',
                'lb15CmH': 'pr. lb. m. 15cm ',
                'lb30CmI': 'pr. lb. m. 30cm',
                'lb40CmK': 'pr. lb. m. 40cm',
                'lb60CmL': 'pr. lb. m. 60cm',
                'lbIndVangeM': 'ind.vange + stødtr. påudv. Trappe',
            },
            'treatmentType5':{
                'lbM2A': 'M2 200',
                'lbM2B': 'M2 201-500',
                'lbM2C': '501->',
                'lbRammerD': 'M2 0-20',
                'lbRuderE': 'Trinflader + repos'
            },
            'treatmentType6':{
                'lbM2A': 'Jern, rør og beholdere',
                'lbM2C': 'Rør, fladog vinkeljern',
                'lbRammerD': 'Rør, fladog vinkeljern',
                'lbKantG': 'Gasmålere',
                'lb40CmK': 'Gasmålerholdere',
                'lb60CmL': 'Luftriste',
                'lbIndVangeM': 'Muffer'
            }
        },
        'BUTTONS':{
            'Add':'Tilføje',
            'BTNSAVE': 'Gem',
            'BACK': 'Tilbage',
        },
        'MESSAGES': {
            'NORECORD': 'Ingen registrering fundet',
            'NO_REMINDER_RECORD': 'Ingen påmindelser fundet',
            'NO_PROJECT_RECORD': 'Ingen Projekter fundet',
            'Created': 'Oprettet med succes.',
            'Updated': 'Opdateret med succes.',
            'Deleted': 'Slettet med succes.',
            'Failed': 'Noget gik galt !',
          },
    }
};